import React from 'react';
import {
	Loader,
	BaasicTable,
	TableFilter,
	BaasicConfirmModal,
	BaasicHeader,
	BaasicSelect,
	BaasicTableExport,
} from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { ShipmentInfoReturnStore } from 'modules/shipment-info-return/stores';
import ReactTooltip from 'react-tooltip';
import { FileNames } from 'common/constants';

const ShipmentInfoReturnListTemplate = ({
	t,
	viewStore,
	viewStore: {
		listStore,
		tableData,
		queryUtility,
		loading,
		baasicTableSettingsViewStore,
		columnFilterSetup,
		removeFiltersModal: { removeFiltersConfirm },
		showActions,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<section className="flex--grow--1">
			<BaasicHeader
				title="SHIPMENTSTATUSVIEW.RETURNSHIPMENTS"
				baasicTableSettingsViewStore={baasicTableSettingsViewStore}
			>
				<BaasicTableExport tableViewStore={viewStore} fileTitle={FileNames.ShipmentInfoReturn} />
			</BaasicHeader>
			<BaasicTable
				{...{
					listStore,
					tableData,
					queryUtility,
					showActions,
					viewStore,
				}}
				data={listStore.data.slice()}
				actions={viewStore}
			/>
			<ReactTooltip />
			<TableFilter {...{ viewStore, columnFilterSetup }} />
			<BaasicConfirmModal modalParams={removeFiltersConfirm} />
		</section>
	);
};

export default defaultTemplate(ShipmentInfoReturnListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/shipment-info-return/pages/ShipmentInfoReturnListTemplate.jsx